// @flow
import { StyleSheet } from "react-native";
import { colors, fontSizes } from "../../../constants/styles";

export const inputTextStyles = StyleSheet.create({
  inputLabelText: {
    color: colors.maroon,
    fontSize: fontSizes.x10,
    fontFamily: "HelveticaNeue-Medium",
    letterSpacing: 1,
    textAlign: "left",
  },
  inputContainer: {
    marginBottom: 40,
  },
  inputText: {
    fontFamily: "HelveticaNeue",
    paddingTop: 12,
    paddingBottom: 12,
    fontSize: fontSizes.x16,
    color: colors.maroon,
    borderColor: colors.maroon,
    borderBottomWidth: 1,
  },
  leftAlign: {
    textAlign: "left",
  },
  rightAlign: {
    textAlign: "right",
  },
  darkLabelText: {
    color: colors.darkTextLabelColor,
  },
  darkInput: {
    borderBottomColor: colors.maroon,
    borderBottomWidth: 1,
    color: colors.maroon,
  },
  lastField: {
    marginBottom: 20,
  },
  disabledInput: {
    color: colors.gray,
    borderBottomColor: colors.gray,
  },
});

export const inputErrorStyles = StyleSheet.create({
  errorContainer: {
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "row",
    marginTop: 10,
    marginBottom: 5,
    paddingVertical: 5,
    backgroundColor: colors.white,
  },
  errorLabel: {
    color: colors.albaikRed,
    fontSize: fontSizes.x12,
    letterSpacing: 0,
  },
});
